import { useQuery } from '@tanstack/react-query';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import useWindowSize from '../../utils/useWindowSize';
import { ImageType, ProductCardType } from './useProducts';

type HomePromo = {
  destinationUrl?: string;
  defaultDestinationUrl?: string;
  title?: string;
  text?: string;
  sorting?: number;
  localizedImage?: ImageType;
  imageDefault?: ImageType;
};

export enum HomeContentType {
  HOME_HERO = 'HOME_HERO',
  HOME_PRODUCTS_PUSH = 'HOME_PRODUCTS_PUSH',
  HOME_PROMO_PUSH = 'HOME_PROMO_PUSH',
  HOME_FOOTER_PROMO_PUSH = 'HOME_FOOTER_PROMO_PUSH',
  HOME_TEXT = 'HOME_TEXT',
}

export type HomeContent = {
  id: number;
  sorting: number;
  contentType: HomeContentType;
  promoTitle?: string;
  promoText?: string;
  title?: string;
  text?: string;
  products: (ProductCardType & { sorting: number })[] | undefined;
  promos: HomePromo[] | undefined;
};

export default function useHome() {
  const { width } = useWindowSize();
  const { licenseId, localeId, mobile } = useLocaleQueryFilter({
    mobile: width < 970,
  });
  const accessPhysicalProduct = window.config?.ACCESS_PHYSICAL_PRODUCT;
  const accessBonus = window.config?.ACCESS_BONUS;

  return useQuery<HomeContent[], Error>(
    [
      'home',
      { licenseId, localeId, mobile, accessPhysicalProduct, accessBonus },
    ],
    {
      staleTime: 1000,
      enabled: !!licenseId && !!localeId,
    },
  );
}
